// extracted by mini-css-extract-plugin
export var aniSpin = "Footer-module--ani-spin--ebEJA";
export var black = "#000";
export var el = "Footer-module--el--7aeLX";
export var el__column = "Footer-module--el__column--v71r9";
export var el__credits = "Footer-module--el__credits--UTIRj";
export var el__credits__item = "Footer-module--el__credits__item--jcOII";
export var el__inner = "Footer-module--el__inner--b8BM6";
export var largeDesktop = "1400px";
export var largePhone = "480px";
export var mediumDesktop = "1300px";
export var smallDesktop = "1100px";
export var smallPhone = "320px";
export var tabletLandscape = "1024px";
export var tabletPortrait = "768px";
export var white = "#fff";
export var xlDesktop = "1600px";
export var xxlDesktop = "1900px";
export var xxxlDesktop = "2150px";